import axios from "axios";
import * as Constants from "../utils/constants";

// Function to set the Authorization header
export const setAuthToken = (token) => {
  if (token) {
    Constants.CONFIG.headers = {
      ...Constants.CONFIG.headers,
      Authorization: `Bearer ${token}`,
    };
  } else {
    delete Constants.CONFIG.headers["Authorization"];
  }
};

export const login = async (username, password) => {
  try {
    const response = await axios.post(
      Constants.LOGIN,
      {
        username: username,
        password: password,
      },
      Constants.CONFIG
    );
    if (response.status === 200) {
      const token = response.data.accessToken;
      const userId = response.data.id;
      const emailUser = response.data.email;
      localStorage.setItem("token", token);
      localStorage.setItem("userId", userId);
      localStorage.setItem("emailUser", emailUser);
      localStorage.setItem("login", "true");
      localStorage.removeItem("logout");
      setAuthToken(token);
      return "success";
    } else if (response.status === 500) {
      return response;
    } else {
      return "Invalid credentials. Please try again.";
    }
  } catch (error) {
    return "error";
  }
};

export const logout = async () => {
  try {
    const response = await axios.post(Constants.LOGOUT, Constants.CONFIG);
    if (response.status === 200) {
      localStorage.setItem("logout", "true");
      localStorage.removeItem("login");
      localStorage.removeItem("token");
      localStorage.removeItem("userId");
    }
    return response;
  } catch (error) {
    return error.message;
  }
};

export const register = async (username, email, password) => {
  try {
    const response = await axios.post(
      Constants.REGISTER,
      {
        username: username,
        email: email,
        password: password,
      },
      Constants.CONFIG
    );

    if (response.status === 200) {
      return "success";
    }
  } catch (error) {
    return error;
  }
};

export const verify = async (email, code) => {
  try {
    const response = await axios.post(
      Constants.VERIFY,
      {
        email: email,
        verificationCode: code,
      },
      Constants.CONFIG
    );

    if (response.status === 200) {
      return "success";
    }
  } catch (error) {
    console.error("Error Response:", error.response?.data);
    return error;
  }
};

// update password

export const update = async (oldPassword, newPassword) => {
  try {
    const response = await axios.post(
      Constants.UPDATEPASSWORD,
      {
        oldPassword: oldPassword,
        newPassword: newPassword,
      },
      Constants.CONFIG
    );

    if (response.status === 200) {
      return "success";
    }
  } catch (error) {
    console.error("Error Response:", error.response?.data);
    return error;
  }
};

// Change password
export const resetPass = async (email) => {
  try {
    const response = await axios.post(
      Constants.RESETPASS,
      {
        email: email,
      },
      Constants.CONFIG
    );

    if (response.status === 200) {
      return "success";
    }
  } catch (error) {
    console.error("Error Response:", error.response?.data);
    return error;
  }
};

export const changePass = async (token, newPassword) => {
  try {
    const response = await axios.post(
      Constants.CHANGEPASS,
      {
        token: token,
        newPassword: newPassword,
      },
      Constants.CONFIG
    );

    if (response.status === 200) {
      return "success";
    }
  } catch (error) {
    console.error("Error Response:", error.response?.data);
    return error;
  }
};
